// Generated by genversion.
export const version = '2.0.0'
